import React, { useState } from 'react';
import "./CSS/LoginSignup.css";

const LoginSignup = () => {
  const [state, setState] = useState("Login");
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: ""
  });

  const API_BASE = process.env.REACT_APP_API_BASE_URL; // from .env

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const login = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (data.success) {
        localStorage.setItem('auth-token', data.token);
        window.location.replace('/');
      } else {
        alert(data.errors || "Login failed!");
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("Server error. Try again later.");
    }
  };

  const signup = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/auth/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (data.success) {
        localStorage.setItem('auth-token', data.token);
        window.location.replace('/');
      } else {
        alert(data.errors || "Signup failed!");
      }
    } catch (err) {
      console.error("Signup error:", err);
      alert("Server error. Try again later.");
    }
  };

  return (
    <div className='loginsignup'>
      <div className="loginsignup-container">
        <h1>{state}</h1>
        <div className='loginsignup-feilds'>
          {state === "Sign Up" && (
            <input
              name='username'
              value={formData.username}
              onChange={changeHandler}
              type="text"
              placeholder='Your Name'
            />
          )}
          <input
            name='email'
            value={formData.email}
            onChange={changeHandler}
            type="email"
            placeholder='Email Address'
          />
          <input
            name='password'
            value={formData.password}
            onChange={changeHandler}
            type="password"
            placeholder='Password'
          />
        </div>
        <button onClick={() => state === "Login" ? login() : signup()}>
          Continue
        </button>
        {state === "Sign Up" ? (
          <p className="loginsignuo-login">
            Already have an account <span onClick={() => setState("Login")}>Login Here</span>
          </p>
        ) : (
          <p className="loginsignuo-login">
            Create an account <span onClick={() => setState("Sign Up")}>Click Here</span>
          </p>
        )}

        <label className="loginsignup-agree">
          <input type="checkbox" id="terms" />
          <span>By continuing, I agree to the terms of use & privacy policies.</span>
        </label>
      </div>
    </div>
  );
};

export default LoginSignup;
